import { axiosInstance, baseURL, handleErrors } from "./auth";

export const NOTIFICATION_LIST = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/socketNotification/list`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const NOTIFICATION_READ_SINGLE = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/socketNotification/readSingle`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const NOTIFICATION_READ_ALL = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/socketNotification/readAll`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};
export const UNREADCOUNT = async (params) => {
    try {
        const response = await axiosInstance.post(`${baseURL}/socketNotification/unreadCount`, params);
        return response.data;
    } catch (error) {
        handleErrors(error)
    }
};